import React from 'react'
import { match } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import Calls from "~/components/pages/features/components/detail/calls/calls";
import Admin from "~/components/pages/features/components/detail/admin/admin";
import Report from './report'
import Autoinformator from "~/components/pages/features/components/detail/autoinformator/autoinformator";
import AutoCall from "~/components/pages/features/components/detail/auto-call/auto-call";
import Quality from "~/components/pages/features/components/detail/quality/quality";

interface IParams {
  subview: string
}

interface IStoriesCompanies {
  match: match<IParams>
}

interface IstoryPage {
  title: string
  component: React.ReactNode
}

interface IstoryPages {
  [item: string]: IstoryPage
}

const storyPages: IstoryPages = {
  calls: {
    title: 'Приложение для звонков',
    component: <Calls />
  },
  admin: {
    title: 'Приложение администратора',
    component: <Admin />
  },
  reports: {
    title: 'Отчеты',
    component: <Report />
  },
  autoinformator: {
    title: 'Автоиформатор',
    component: <Autoinformator/>
  },
  auto_call: {
    title: 'Автоперезвон',
    component: <AutoCall/>
  },
  quality: {
    title: 'Оценка качества',
    component: <Quality />
  },
}


export const Detail: React.FC<IStoriesCompanies> = (props) => {
  const { match } = props
  const { subview } = match.params
  return (
    <DocumentTitle title={`«onlinePBX» - ${storyPages[subview].title}`}>
      <div className='onlinepbx__head'>
        {storyPages[subview].component}
      </div>
    </DocumentTitle>
  )
}

export default Detail
